import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Image from 'gatsby-image';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';



import { useStaticQuery, graphql } from "gatsby"


import Link from '@material-ui/core/Link';



import AlbumPageStyle from "assets/jss/material-kit-react/views/AlbumPage.jsx";


import image from "assets/img/gallery/_MG_5001.jpg";


const AlbumPage = ({ classes, ...rest }) => {
  const [open, setOpen] = React.useState(false);



  
  

  const handleClose = () => {
    setOpen(false);
  };


  const data = useStaticQuery(graphql`
    query  {
      joker: file(name: { eq: "sideJoker" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      },
      room1: file(name: { eq: "_MG_4888" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      },
      room2: file(name: { eq: "_MG_4954" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      },
      boards: file(name: { eq: "_MG_4992" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      }
      menu: file(name: { eq: "_MG_4951" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      },
      back: file(name: { eq: "_MG_4899" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      },
      games: file(name: { eq: "_MG_4887" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      },
      storeShelf: file(name: { eq: "_MG_4980" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      },
      cbd: file(name: { eq: "_MG_4984" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      },
      topRight: file(name: { eq: "_MG_4872" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      }
    }
  `);

  return (
    <div>
      <Header
        absolute
        color="transparent"
        brand="Material Kit React"
        rightLinks={<HeaderLinks />}
        {...rest}
      />

      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center"
        }}
      >

        <div className={classes.container}>
          <GridContainer justify="center">
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"

              style={classes.modal}
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <div className={classes.paper} style={{ width: '25rem' }}>
                  < Image fluid={data.joker.childCloudinaryAsset.fluid} alt="avatar" style={{ margin: "10px 5px" }} />
                </div>
              </Fade>
            </Modal>

            <GridItem xs={12} sm={12} md={4} >
              <Link href="#" onClick={e => e.preventDefault()}>
                < Image fluid={data.joker.childCloudinaryAsset.fluid} alt="avatar" style={{ margin: "10px 5px" }} />
              </Link>
            </GridItem>


            <GridItem xs={12} sm={12} md={4}>
              <Link href="#" onClick={e => e.preventDefault()}>
                <Image fluid={data.menu.childCloudinaryAsset.fluid} alt="avatar" style={{ margin: "10px 5px" }} />
              </Link>
              <br></br>
              <Link href="#" onClick={e => e.preventDefault()}>
                <Image fluid={data.boards.childCloudinaryAsset.fluid} alt="avatar" style={{ margin: "10px 5px" }} />
              </Link>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Link href="#" onClick={e => e.preventDefault()}>
                <Image fluid={data.topRight.childCloudinaryAsset.fluid} alt="avatar" style={{ margin: "10px 5px" }} />
              </Link>
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <Link href="#" onClick={e => e.preventDefault()}>
                <Image fluid={data.back.childCloudinaryAsset.fluid} alt="avatar" style={{ margin: "10px 5px" }} />
              </Link>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Link href="#" onClick={e => e.preventDefault()}>
                <Image fluid={data.storeShelf.childCloudinaryAsset.fluid} alt="avatar" style={{ margin: "10px 5px" }} />
              </Link>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Link href="#" onClick={e => e.preventDefault()}>
                <Image fluid={data.cbd.childCloudinaryAsset.fluid} alt="avatar" style={{ margin: "10px 5px" }} />
              </Link>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Link href="#" onClick={e => e.preventDefault()}>
                <Image fluid={data.room1.childCloudinaryAsset.fluid} alt="avatar" style={{ margin: "10px 5px" }} />
              </Link>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Link href="#" onClick={e => e.preventDefault()}>
                <Image fluid={data.games.childCloudinaryAsset.fluid} alt="avatar" style={{ margin: "10px 5px" }} />
              </Link>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Link href="#" onClick={e => e.preventDefault()}>
                <Image fluid={data.room2.childCloudinaryAsset.fluid} alt="avatar" />
              </Link>
              <br></br>
            </GridItem>

          </GridContainer>
          <br></br>
          <br></br>
          <br></br>
        </div>
        <Footer whiteFont />
      </div>
    </div >
  );
}


export default withStyles(AlbumPageStyle)(AlbumPage);
